/**
 * Color constants for Private Region charts
 */

export const GPU_CHART_COLORS = ['#335CFF', '#335CFFCC', '#335CFF99', '#335CFF66', '#335CFF33']

export const USAGE_CHART_COLORS = {
  actualUsage: '#00BAE2',
  totalAvailable: '#335CFF',
}
